import UserForm from 'containers/UserForm/themes/UserFormLight.css';

export default { UserForm };
